import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

export const ConfirmOrderDialog = ({
  open, onOpenChange, selectedOrder,
  deliveryDate, setDeliveryDate, deliveryTime, setDeliveryTime,
  onConfirm,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="confirm-order-dialog">
      <DialogHeader>
        <DialogTitle>Confirm Order - #{selectedOrder?.id?.slice(0, 8)}</DialogTitle>
      </DialogHeader>
      <form onSubmit={(e) => { e.preventDefault(); onConfirm(); }}>
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium">Delivery Date</label>
            <Input type="date" value={deliveryDate} onChange={(e) => setDeliveryDate(e.target.value)} required data-testid="delivery-date-input" />
          </div>
          <div>
            <label className="text-sm font-medium">Delivery Time</label>
            <Input type="time" value={deliveryTime} onChange={(e) => setDeliveryTime(e.target.value)} required data-testid="delivery-time-input" />
          </div>
        </div>
        <DialogFooter className="mt-6">
          <Button type="submit" style={{ background: '#2B5339' }} data-testid="submit-confirm-btn">Confirm</Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);
